module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.d6e6a4d9.svg";